/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
// 多产品置顶功能：根据 URL 参数中的 product_id，将对应产品卡片依次置顶
document.addEventListener("DOMContentLoaded", function () {
  const urlParams = new URLSearchParams(window.location.search);
  const productIdParam = urlParams.get("product_id");
  if (!productIdParam) return;

  const productIds = productIdParam.split(",").map(id => id.trim()).filter(Boolean);
  if (productIds.length === 0) return;

  const productCards = document.querySelectorAll('[data-product-id]');
  const container = productCards.length > 0 ? productCards[0].parentElement : null;
  if (!container) return;

  // 将符合 ID 的卡片按顺序提取
  productIds.forEach(pid => {
    const target = Array.from(productCards).find(el => el.dataset.productId === pid);
    if (target && container.contains(target)) {
      container.insertBefore(target, container.firstChild);
    }
  });
});






  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
